import { defineStore } from 'pinia';
import { updateSettings, updateIgniteSettings } from '@/services/SettingsService';
import { useWaveformStore } from './waveform';
import { DEFAULT_WAVEFORM_COLORS } from '@/constants';

export const useSettingStore = defineStore('setting', {
	state: () => ({
		should_auto_fill_DMX_pre_fire: false,
		default_dmx_universe: 1,
		auto_fill_pre_fire: false,
		auto_pre_fire_time: 0,
		settings: {
			shift_step_markers_after_previous_events_duration: true,
			draw_event_markers: true,
			draw_STEP_events: false,
			cue_marker_color: DEFAULT_WAVEFORM_COLORS.cue_marker_color,
			waveform_color: DEFAULT_WAVEFORM_COLORS.waveform_color,
			waveform_progress_color: DEFAULT_WAVEFORM_COLORS.waveform_progress_color,
			waveform_background_color: DEFAULT_WAVEFORM_COLORS.waveform_background_color,
			waveform_playhead_color: DEFAULT_WAVEFORM_COLORS.waveform_playhead_color,
			allow_browser_spell_checking: true,
			max_waveform_event_drawer_height: 133,
			disable_dmx_ramp_feature: false,
			hide_waveform: false,
		},
		ignite_settings: null,
		is_total_events_expanded: true,

		is_fireworks_widget_expanded: false,
		is_dmx_widget_expanded: false,
		is_show_details_widget_expanded: false,

		is_fireworks_section_refresh_button_highlighted: false,

		elevate_studio_user_actions_broadcast_channel: undefined,
		interactive_modal_id: undefined,

		open_feedback_modal: false,

		is_preferences_UI_open: false,
	}),

	actions: {
		setSettingInfo(settings) {
			this.settings = { ...this.settings, ...settings };
			// update the layout
			if (settings.layout === 'classic') {
				const waveform_store = useWaveformStore();
				if (waveform_store != undefined) {
					waveform_store.setWaveformLayout(false);
				}
			}
		},
		async updateSetting(key, value, is_ignite = false) {
			try {
				const response = is_ignite == true ? await updateIgniteSettings(key, value) : await updateSettings(key, value);
				if (response?.error != undefined) {
					throw new Error(JSON.stringify(response.error));
				} else {
					if (is_ignite == true) {
						this.ignite_settings = {
							...this.ignite_settings,
							[key]: value,
						};
					} else {
						this.settings = {
							...this.settings,
							[key]: value,
						};
					}
				}
			} catch (error) {
				console.log('🚀 ~ file: setting.js:25 ~ updateSetting ~ error:', error);
				throw new Error(error);
			}
		},
		setIgniteSettingInfo(settings) {
			this.ignite_settings = settings;
		},
		resetEventMarkerColor() {
			this.settings.cue_marker_color = DEFAULT_WAVEFORM_COLORS.cue_marker_color;
		},
		resetWaveformColor() {
			this.settings.waveform_color = DEFAULT_WAVEFORM_COLORS.waveform_color;
		},
		resetWaveformProgressColor() {
			this.settings.waveform_progress_color = DEFAULT_WAVEFORM_COLORS.waveform_progress_color;
		},
		resetWaveformBackgroundColor() {
			this.settings.waveform_background_color = DEFAULT_WAVEFORM_COLORS.waveform_background_color;
		},
		resetWaveformPlayheadColor() {
			this.settings.waveform_playhead_color = DEFAULT_WAVEFORM_COLORS.waveform_playhead_color;
		},
		setInteractiveModalId(value) {
			this.interactive_modal_id = value;
		},
		setFeedbackModalVisibility(value) {
			this.open_feedback_modal = value;
		},
	},
	// watch: {
	//For some reason the is_total_events_expanded watcher works but all of the other ones do not. It would be preferred to have this logic centralized but it has been added to each of the firework, dmx, and show details components
	// is_total_events_expanded: (new_value) => {
	// 	console.log('watch is_total_events_expanded', new_value);
	// },
	// is_fireworks_widget_expanded: (new_value) => {
	// 	console.log('watch is_fireworks_widget_expanded', new_value);
	// 	// if (new_value != true) {
	// 	// 	return;
	// 	// }
	// 	// const store = useSettingStore();
	// 	// store.is_dmx_widget_expanded = false;
	// 	// store.is_show_details_widget_expanded = false;
	// },
	// is_dmx_widget_expanded: function (new_value) {
	// 	console.log('watch is_dmx_widget_expanded', new_value);
	// 	if (new_value != true) {
	// 		return;
	// 	}
	// 	this.is_fireworks_widget_expanded = false;
	// 	this.is_show_details_widget_expanded = false;
	// },
	// is_show_details_widget_expanded: function (new_value) {
	// 	console.log('watch is_show_details_widget_expanded', new_value);
	// 	if (new_value != true) {
	// 		return;
	// 	}
	// 	this.is_fireworks_widget_expanded = false;
	// 	this.is_dmx_widget_expanded = false;
	// },
	// },
});
